import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './SuperXSection.css';

const SuperXSection = () => {
  const [showWinners, setShowWinners] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);

  const winnersVideos = [
    { id: '47gn9CXfG3k' },
    { id: 'I-hkSsk7xVE' },
    { id: 'PNebti2x_fI' },
    { id: 'kkQ11faLfgA' },
    { id: '4S-4UmZ195k' },
  ];

  return (
    <section className="ucp-section superx-section">
      <div className="superx-container">
        <div className="superx-content">
          <motion.div
            className="superx-info"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <motion.img
              src="/assets/superx/images/C2wSuperx.png"
              alt="Super-X Logo"
              className="superx-main-logo"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
            />
            <h2>Accelerate Your Career <br /><span className="blue-text">SuperX Journey</span></h2>
            <p>
              SuperX is the project competition where the students learn and build the project.
            </p>

            <button className="btn-superx" onClick={() => setShowWinners(true)}>
              OUR WINNERS <span>→</span>
            </button>
          </motion.div>

          <motion.div
            className="superx-visual"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="video-frame">
              <div className="video-inner">
                <iframe
                  src="https://www.youtube.com/embed/47gn9CXfG3k"
                  title="SuperX Journey Video"
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="video-glow"></div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Interactive Winners Hall of Fame */}
      <AnimatePresence>
        {showWinners && (
          <motion.div
            className="winners-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="winners-modal"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 50, opacity: 0 }}
            >
              <div className="modal-header">
                <div className="header-titles">
                  <span className="gold-text">ALUMNI SUCCESS</span>
                  <h3>SuperX Hall of Fame</h3>
                </div>
                <button className="close-winners" onClick={() => { setShowWinners(false); setActiveVideo(null); }}>×</button>
              </div>

              <div className="winners-layout">
                {/* Cinema Display */}
                <div className="cinema-display">
                  <div className="active-video-wrapper">
                    <iframe
                      src={`https://www.youtube.com/embed/${activeVideo || winnersVideos[0].id}?autoplay=1`}
                      title="Main Video"
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>

                {/* Playlist Sidebar */}
                <div className="winners-playlist">
                  <p className="playlist-title">WATCH JOURNEYS</p>
                  <div className="playlist-scroll">
                    {winnersVideos.map((video, index) => (
                      <motion.div 
                        key={video.id} 
                        className={`playlist-item ${activeVideo === video.id || (!activeVideo && index === 0) ? 'active' : ''}`}
                        onClick={() => setActiveVideo(video.id)}
                        whileHover={{ scale: 1.05 }}
                      >
                        <div className="item-thumb">
                          <img src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`} alt="thumb" />
                          <div className="thumb-play">▶</div>
                          {(activeVideo === video.id || (!activeVideo && index === 0)) && (
                            <div className="now-playing-tag">
                              <span className="play-pulse"></span>
                              NOW PLAYING
                            </div>
                          )}
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default SuperXSection;
